import { render, staticRenderFns } from "./FinancialMediaIntelligent.vue?vue&type=template&id=2d8e28b3&scoped=true&"
import script from "./FinancialMediaIntelligent.vue?vue&type=script&lang=js&"
export * from "./FinancialMediaIntelligent.vue?vue&type=script&lang=js&"
import style0 from "./FinancialMediaIntelligent.vue?vue&type=style&index=0&id=2d8e28b3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e28b3",
  null
  
)

export default component.exports